import { motion } from 'framer-motion';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { useReducedMotion } from '@/hooks/useReducedMotion';

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
}

export function NavLink({ to, children }: NavLinkProps) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <RouterNavLink
      to={to}
      className={({ isActive }) =>
        `relative px-4 py-2 text-xl font-medium transition-colors ${
          isActive ? 'text-[#0000FF]' : 'text-foreground hover:text-[#0000FF]'
        }`
      }
    >
      {({ isActive }) => (
        <>
          {children}
          {isActive && (
            <motion.div
              layoutId="activeNavIndicator"
              className="absolute bottom-0 left-0 right-0 h-0.5"
              style={{ backgroundColor: '#0000FF' }}
              transition={
                prefersReducedMotion
                  ? { duration: 0 }
                  : { type: 'spring', stiffness: 380, damping: 30 }
              }
            />
          )}
        </>
      )}
    </RouterNavLink>
  );
}

